export default __webpack_public_path__ + "957cad10b6c8bf85d9aee2b6389ede45.svg";